import gql from "graphql-tag.macro";
import { v4 as uuidv4 } from "uuid";

const queryChainInstance = gql`
    query {
        chaininstance {
            _id
            chain {
                id
                name
                feature
                textPrompt
                action
                promptNodes
            }
            systemChain {
                id
                name
                feature
                textPrompt
                action
                promptNodes
            }
        }
    }
`;

const gqlUpsertChainInstance = gql`
    mutation upsertChain($chain: [chainInput!]!, $systemChain: [chainInput!]!) {
        upsertChainInstance(chain: $chain, systemChain: $systemChain) {
            _id
            chain {
                id
                name
                feature
                textPrompt
                action
                promptNodes
            }
            systemChain {
                id
                name
                feature
                textPrompt
                action
                promptNodes
            }
        }
    }
`;
export const loadChainInstance = async ({ client }) => {
    const {
        data: { chaininstance },
    } = await client.query({
        query: queryChainInstance,
        variables: {},
        fetchPolicy: "no-cache",
    });
    console.log("loadChainInstance", chaininstance);

    chaininstance?.chain?.forEach(chain => {
        for (const key in chain) {
            if (chain[key] === null) {
                delete chain[key];
            }
        }
        delete chain["__typename"];
    });

    chaininstance?.systemChain?.forEach(systemChain => {
        for (const key in systemChain) {
            if (systemChain[key] === null) {
                delete systemChain[key];
            }
        }
        delete systemChain["__typename"];
    });

    return chaininstance;
};

export const upsertChainInstance = async ({ chain, systemChain }, { client }) => {
    const {
        data: { upsertChainInstance: chaininstance },
    } = await client.mutate({
        mutation: gqlUpsertChainInstance,
        variables: { chain, systemChain },
    });
    console.log("upsertChainInstance", chaininstance);
    chaininstance?.chain?.forEach(chain => {
        for (const key in chain) {
            if (chain[key] === null) {
                delete chain[key];
            }
        }
        delete chain["__typename"];
    });

    chaininstance?.systemChain?.forEach(systemChain => {
        for (const key in systemChain) {
            if (systemChain[key] === null) {
                delete systemChain[key];
            }
        }
        delete systemChain["__typename"];
    });

    return chaininstance;
};

export const chainInstanceActionResult = async ({ actionResult }) => {
    if (window?.app?.Duchess) {
        const channel = `/duchess/AIController/${actionResult.projectId}`;
        try {
            window.app.Duchess.PublishUpdate(channel, { actionResult });
        } catch (e) {
            console.error("chaininstance.api.chainInstanceActionResult", e);
        }
    }
};

export const defaultChainInstance = () => {
    return {
        chain: () => [
            {
                id: uuidv4(),
                name: "Auto Content",
                feature: "content-generator",
                textPrompt: "How can I help you?",
                action: "replace",
                promptNodes: [
                    "Generate content for this heading: {heading_title} with these notes as the brief {notes_current}. Do not address anything in this heading content that may be addressed elsewhere in this table of contents: {doc_toc}. The overall brief for the document is {doc_brief}",
                ],
            },
        ],
        systemChain: () => [
            {
                id: uuidv4(),
                name: "document-builder.generate-table-of-contents",
                feature: "system-prompt",
                promptNodes: [
                    "Generate a table of contents for a document titled '{doc_title}' with this brief '{doc_brief}'",
                    "Respond as JSON format exactly like: [{heading: '', notes: '', subheadings: [{heading: '', notes: '', subheadings: []]}] leaving the notes empty. Do not include the title in the response.",
                    "Subheadings up to {doc_subheadings_level} levels deep.",
                ],
            },
            {
                id: uuidv4(),
                name: "document-builder.regenerate-toc-from-feedback",
                feature: "system-prompt",
                promptNodes: [
                    "Generate a table of contents for a document titled '{doc_title}' with this brief '{doc_brief}' based on this feedback: {doc_headings_feedback}",
                    "Respond as JSON format exactly like: [{heading: '', notes: '', subheadings: [{heading: '', notes: '', subheadings: []]}] leaving the notes empty. Do not include the title in the response.",
                    "Subheadings up to {doc_subheadings_level} levels deep.",
                ],
            },
            {
                id: uuidv4(),
                name: "document-builder.generate-notes",
                feature: "system-prompt",
                promptNodes: [
                    "I want you to update the 'notes' value of the 'headings' array",
                    "Follow these instructions: 1. Return the JSON object only, do not include any other text in your response. 2. Do not change the 'title' property, 'brief' property, or 'heading' propery of the 'headings' array",
                    "Write notes for each heading. The notes you respond with should include paragraphs to guide the writer, as well as questions that the writer will need to answer. Respond in the same JSON format. Must be all latin characters",
                    "{doc_toc}"
                ],
            },
            {
                id: uuidv4(),
                name: "document-builder.generate-notes-from-feedback",
                feature: "system-prompt",
                promptNodes: [
                    "I want you to update the 'notes' value of the 'headings' array based on this feedback: '{doc_notes_feedback}'",
                    "Follow these instructions: 1. Return the JSON object only, do not include any other text in your response. 2. Do not change the 'title' property, 'brief' property, or 'heading' propery of the 'headings' array",
                    "Write notes for each heading. The notes you respond with should include paragraphs to guide the writer, as well as questions that the writer will need to answer. Respond in the same JSON format. Must be all latin characters",
                    "{doc_toc}"
                ],
            },
        ],
    };
};
